"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M35.9 18.448c0-8.8-6.265-15.961-14.022-15.961S8.155 9.2 7.857 17.552H.1c0 8.8 6.265 15.961 14.022 15.961S27.845 26.8 28.143 18.447zm-14.32-.9c1.641-3.878 3.282-5.37 5.967-5.37a5.348 5.348 0 0 1 5.37 5.37zm.3-14.171c5.967 0 11.038 4.624 12.53 10.889a7.4 7.4 0 0 0-6.862-4.326c-4.923 0-7.011 3.878-8.353 7.607H8.752c.448-7.9 6.115-14.165 13.126-14.165zM18.9 18.448c-1.193 2.536-3.878 7.607-8.652 7.607-4.177 0-7.16-2.983-7.309-7.608zm-4.778 14.17a13.093 13.093 0 0 1-11.785-8.353 8.958 8.958 0 0 0 7.906 4.028c4.624 0 8.8-3.729 11.038-9.845h5.967c-.298 7.905-6.115 14.17-13.126 14.17z" })
);

